import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
  Dropdown,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  fetchId,
  fetchRole,
  selectRole,
  selectDataId,
  editItem,
  addOfficeUser,
  selectDataIdUser,
  fetchIdUser,
  editEmployee,
  removeUserOffice,
  unlockUserUpdate,
  resetUserUpdate,
  selectRoleModal,
  fetchRoleModal,
  editOfficeUser,
} from "../user/userSlice";
import {
  StatusFormatter,
  columnsExportExcel,
  dateDefault,
  formLabelsTheme,
  formatDate,
  formatQuantity,
  getValueOptions,
  iconError,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  sizePerPageList,
  statusInboundFormatter,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
  headerSortingClasses,
} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchGroup1,
  fetchGroup2,
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  fetchParameter4,
  selectGroup1,
  selectGroup2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import { fetchClient } from "../client/clientSlice";
import { selectPagination } from "../../modules/Auth";
import {
  editInbound,
  editInboundAmend,
  editInboundCancel,
  editInboundConfirm,
  editInboundSetstatus,
  fetchGenerateExcel,
  fetchIdInbound,
  fetchVehicleInboundWorkflow,
  removeVehicle,
  selectIdInbound,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectVehicle,
  setPermisionList,
  setPermisionPdiin,
  setPermisionPdiout,
  setPermisionRci,
  setPermisionStorage,
} from "./inboundSlice";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { VehicleCreate } from "./VehicleCreate";
import { VehicleUpload } from "./VehicleUpload";
import { ModalLocationMasterRadio } from "./ModalLocationMasterRadio";
import { InboundCopy } from "./InboundCopy";
import { InboundCancel } from "./InboundCancel";
import { VehicleUploadView } from "./VehicleUploadView";
import { Autocomplete } from "@material-ui/lab";
import { fetchMenuTab, selectMenuTab } from "../menu/menuSlice";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const OverviewEdit = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdInbound);
  const data = useSelector(selectVehicle);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataService = useSelector(selectParameter);
  const dataJobType = useSelector(selectParameter2);

  const dataInbound = useSelector(selectGroup1);
  const dataOutbound = useSelector(selectGroup2);

  const { id } = useParams();
  const paginationSet = useSelector(selectPagination);

  const [vehiclesFilter, setVehiclesFilter] = useState("");
  const [vehiclesFilterValue, setVehiclesFilterValue] = useState("");
  const [row, setRow] = useState(null);
  const [getData, setGetData] = useState(false);
  const [getDataProduct, setGetDataProduct] = useState(false);
  const [getDataColor, setGetDataColor] = useState(false);
  const [getDataModel, setGetDataModel] = useState(false);
  const [color, setColor] = useState("white");

  const dataMenuTab = useSelector(selectMenuTab);
  const [list, setList] = useState([]);

  // initial
  const [formValues, setFormValues] = useState({
    client: {
      value: "",
      error: false,
      required: "Y",
    },
    client_name: {
      value: "",
      error: false,
      required: "Y",
    },
    job_date: {
      value: "",
      error: false,
      required: "Y",
    },
    estimate_delivery: {
      value: "",
      error: false,
      required: "N",
    },

    port_of_loading: {
      value: "",
      error: false,
      required: "N",
    },

    port_of_loading_name: {
      value: "",
      error: false,
      required: "N",
    },
    shipper: {
      value: "",
      error: false,
      required: "N",
    },
    shipper_name: {
      value: "",
      error: false,
      required: "N",
    },
    job_type: {
      value: "",
      error: false,
      required: "Y",
    },
    estimate_arrival: {
      value: "",
      error: false,
      required: "N",
    },
    service_class: {
      value: "",
      error: false,
      required: "Y",
    },
    actual_delivery: {
      value: "",
      error: false,
      required: "Y",
    },
    actual_arrive: {
      value: "",
      error: false,
      required: "Y",
    },
    port_of_discharge: {
      value: "",
      error: false,
      required: "N",
    },
    port_of_discharge_name: {
      value: "",
      error: false,
      required: "N",
    },
    remarks: {
      value: "",
      error: false,
      required: "N",
    },
    inbound: {
      value: "DOM",
      error: false,
      required: "N",
    },
    outbound: {
      value: "DOM",
      error: false,
      required: "N",
    },
  });

  // initial
  const [formVehicle, setFormVehicle] = useState({
    master_code: {
      value: "",
      error: false,
      required: "Y",
    },
    master_code_name: {
      value: "",
      error: false,
      required: "Y",
    },
    von: {
      value: "",
      error: false,
      required: "N",
    },
    model_code: {
      value: "",
      error: false,
      required: "N",
    },
    model_code_name: {
      value: "",
      error: false,
      required: "N",
    },

    model_name: {
      value: "",
      error: false,
      required: "N",
    },

    model_year: {
      value: "",
      error: false,
      required: "N",
    },
    engine_no: {
      value: "",
      error: false,
      required: "N",
    },
    vin: {
      value: "",
      error: false,
      required: "Y",
    },
    product_desc: {
      value: "",
      error: false,
      required: "N",
    },
    color_code: {
      value: "",
      error: false,
      required: "N",
    },
    color_code_name: {
      value: "",
      error: false,
      required: "N",
    },
    color_name: {
      value: "",
      error: false,
      required: "N",
    },
    production_date: {
      value: "",
      error: false,
      required: "N",
    },
    key_no: {
      value: "",
      error: false,
      required: "N",
    },
    baseuom: {
      value: "UNT",
      error: false,
      required: "N",
    },
    net_weight: {
      value: "",
      error: false,
      required: "N",
    },
    gross_weight: {
      value: "",
      error: false,
      required: "N",
    },
    weight_type: {
      value: "",
      error: false,
      required: "N",
    },
    length: {
      value: "",
      error: false,
      required: "N",
    },
    width: {
      value: "",
      error: false,
      required: "N",
    },
    heigth: {
      value: "",
      error: false,
      required: "N",
    },
    dimension_uom: {
      value: "",
      error: false,
      required: "N",
    },
    volume: {
      value: "",
      error: false,
      required: "N",
    },
    volume_uom: {
      value: "",
      error: false,
      required: "N",
    },
    inbound_rule: {
      value: "N",
      error: false,
      required: "N",
    },
  });

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load

      await dispatch(
        fetchVehicleInboundWorkflow({
          inbound_id: id,
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
      await dispatch(
        fetchParameter({
          paramgroup_code: "VOLUME_MEASUREMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "WEIGTH_MEASUREMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter3({
          paramgroup_code: "BASE_UOM",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter4({
          paramgroup_code: "DISTANCE_MEASUREMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(fetchGroup1("INBOUND_DOM"));
      await dispatch(fetchGroup2("OUTBOUND_DOM"));
      await dispatch(fetchIdInbound(id));
      await dispatch(
        fetchMenuTab({
          menu_url: "/inbound/overview",
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId !== null) {
      setFormValues({
        client: {
          value: dataId.client,
          error: false,
          required: "Y",
        },
        client_name: {
          value: dataId.client_name,
          error: false,
          required: "Y",
        },

        job_date: {
          value:
            dataId.job_date === null
              ? null
              : moment(dataId.job_date).format("YYYY-MM-DD"),
          error: false,
          required: "Y",
        },
        estimate_delivery: {
          value:
            dataId.estimated_delivery === null
              ? null
              : moment(dataId.estimated_delivery).format("YYYY-MM-DD"),
          error: false,
          required: "N",
        },

        port_of_loading: {
          value: dataId.port_of_loading === null ? "" : dataId.port_of_loading,
          error: false,
          required: "N",
        },

        port_of_loading_name: {
          value:
            dataId.port_of_loading_name === null
              ? ""
              : dataId.port_of_loading_name,
          error: false,
          required: "N",
        },
        shipper: {
          value: dataId.shipper,
          error: false,
          required: "N",
        },
        shipper_name: {
          value: dataId.shipper_name,
          error: false,
          required: "N",
        },
        job_type: {
          value: dataId.job_type,
          error: false,
          required: "Y",
        },
        estimate_arrival: {
          value:
            dataId.estimated_arrive === null
              ? null
              : moment(dataId.estimated_arrive).format("YYYY-MM-DD"),
          error: false,
          required: "N",
        },
        service_class: {
          value: dataId.services_class,
          error: false,
          required: "Y",
        },
        actual_delivery: {
          value:
            dataId.actual_delivery === null
              ? null
              : moment(dataId.actual_delivery).format("YYYY-MM-DD"),
          error: false,
          required: "Y",
        },
        actual_arrive: {
          value:
            dataId.actual_arrive === null
              ? null
              : moment(dataId.actual_arrive).format("YYYY-MM-DD"),
          error: false,
          required: "Y",
        },

        port_of_discharge: {
          value:
            dataId.port_of_discharge === null ? "" : dataId.port_of_discharge,
          error: false,
          required: "N",
        },
        port_of_discharge_name: {
          value:
            dataId.port_of_discharge_name === null
              ? ""
              : dataId.port_of_discharge_name,
          error: false,
          required: "N",
        },
        remarks: {
          value: dataId.remarks === null ? "" : dataId.remarks,
          error: false,
          required: "N",
        },
        inbound: {
          value: dataId.inbound === null ? "" : dataId.inbound,
          error: false,
          required: "N",
        },
        outbound: {
          value: dataId.outbound === null ? "" : dataId.outbound,
          error: false,
          required: "N",
        },
      });
    }
  }, [dataId]);

  useEffect(() => {
    if (dataMenuTab.length > 0) {
      const data = dataMenuTab.map((item) => item.menu_name);
      setList(data);
      dispatch(setPermisionList(data));
      const master = dataMenuTab.map((item, index) => {
        if (item.menu_name === "RCI") {
          return dispatch(setPermisionRci(item.permissions));
        }
        if (item.menu_name === "PDI-In") {
          return dispatch(setPermisionPdiin(item.permissions));
        }
        if (item.menu_name === "PDI-Out") {
          return dispatch(setPermisionPdiout(item.permissions));
        }
        if (item.menu_name === "Storage") {
          return dispatch(setPermisionStorage(item.permissions));
        }
      });
    }
  }, [dataMenuTab]);

  useEffect(() => {
    // Add number

    const pageBefore = pageSize * (pageNo - 1);
    const initData =
      data === null
        ? []
        : data.map((item, index) => {
            return {
              ...item,
              no: index + 1 + pageBefore,
            };
          });
    setTableDataVehicle(initData);
  }, [data, pageSize, pageNo]);

  const [tableDataVehicle, setTableDataVehicle] = useState(data);

  // HanldeSave

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }

    const params = {
      inbound_id: id,
      client: formValues.client.value,
      shipper: formValues.shipper.value,
      job_date: formValues.job_date.value,
      job_type: formValues.job_type.value,
      estimated_delivery: formValues.estimate_delivery.value,
      estimated_arrive: formValues.estimate_arrival.value,
      actual_delivery: formValues.actual_delivery.value,
      actual_arrive: formValues.actual_arrive.value,
      port_of_loading: formValues.port_of_loading.value,
      port_of_discharge: formValues.port_of_discharge.value,
      services_class: formValues.service_class.value,
      remarks: formValues.remarks.value,
      inbound: formValues.inbound.value,
      outbound: formValues.outbound.value,
    };

    try {
      const response = await dispatch(editInbound(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  console.log(formValues, "formValues");

  const [showClient, setShowClient] = useState(false);
  const [showLocationMaster, setShowLocationMaster] = useState(false);
  const [showShipper, setShowShipper] = useState(false);

  const [typeLocation, setTypeLocation] = useState("");

  const [fields, setFields] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  const vehiclesOptions = [
    {
      value: "vin",
      label: "VIN",
    },
    {
      value: "von",
      label: "VON",
    },
    {
      value: "master_code",
      label: "Master Code ",
    },
    {
      value: "model_code",
      label: "Model Code ",
    },
    {
      value: "color_code",
      label: "Color Code ",
    },
  ];

  const handleChangeVehicles = (e) => {
    if (e === null) {
      e = undefined;
      setVehiclesFilter("");
    } else {
      setVehiclesFilter(e.value);
    }
  };

  const handleSearch = async () => {
    let params = {};

    params[vehiclesFilter] = vehiclesFilterValue;
    params.inbound_id = id;
    params.pageNo = 1;
    params.pageSize = 10;

    try {
      const response = await dispatch(fetchVehicleInboundWorkflow(params));
      if (response.payload.data.status === 200) {
        window.scrollTo(0, 850);
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      console.log("if");

      let params = {};

      params[vehiclesFilter] = vehiclesFilterValue;
      params.inbound_id = id;
      params.pageNo = page;
      params.pageSize = sizePerPage;
      try {
        const response = await dispatch(fetchVehicleInboundWorkflow(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      const dataCopy = [...data]; // Membuat salinan dari array data
      if (sortOrder === "asc") {
        result = dataCopy.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = dataCopy.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
      setTableDataVehicle(dataCopy);
    }
  };

  const options = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };

  const handleDelete = async (e, row) => {
    const params = [{ vehicle_id: `${row.vehicle_id}` }];
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeVehicle({ data: params }));
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await dispatch(fetchIdInbound(id));
          await dispatch(
            fetchVehicleInboundWorkflow({
              inbound_id: id,
              pageNo: 1,
              pageSize: paginationSet,
            })
          );
          await window.scrollTo(0, 850);
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
          >
            <div
              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
              onClick={(e) => {
                setRow(row);
                setShowVehicle(true);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-light">
                {dataId.inbound_status !== "1010" ? (
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")} />
                ) : (
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
                )}
              </span>
            </div>
          </OverlayTrigger>

          {dataId.inbound_status === "1010" && (
            <OverlayTrigger
              overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
            >
              <div
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                onClick={(e) => handleDelete(e, row)}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
                </span>
              </div>
            </OverlayTrigger>
          )}
        </div>
      </>
    );
  };

  const columns = [
    {
      text: "VIN",
      dataField: "vin",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "VON",
      dataField: "von",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Master Code",
      dataField: "master_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Model Code",
      dataField: "model_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Model Name",
      dataField: "model_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Model Year",
      dataField: "model_year",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Engine No.",
      dataField: "engine_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Key No.",
      dataField: "key_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Color Code",
      dataField: "color_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Color Name",
      dataField: "color_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Require Acc. Installation",
      dataField: "inbound_rule",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: StatusFormatter,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "UOM",
      dataField: "vehicle_uom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },

    {
      text: "Net Weight",
      dataField: "vehicle_netweight",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Gross Weight",
      dataField: "vehicle_grossweight",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Weight UOM",
      dataField: "vehicle_measurement",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Length",
      dataField: "vehicle_length",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Width",
      dataField: "vehicle_width",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Height",
      dataField: "vehicle_height",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Dimension UOM",
      dataField: "vehicle_dimension",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Volume",
      dataField: "vehicle_volume",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Volume UOM",
      dataField: "vehicle_typedimension",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      align: "center",
      headerAlign: "center",
      style: { minWidth: "150px" },
    },
  ];

  // modal Create vehicle
  const [showVehicle, setShowVehicle] = useState(false);
  const [showUpload, setShowUpload] = useState(false);

  const [fileName, setFileName] = useState("Upload Template File");
  const [file, setFile] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const columnsWorkflow = [
    {
      text: "Activity",
      dataField: "activity",
    },
    {
      text: "Planned",
      dataField: "planned",
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Unplanned",
      dataField: "unplanned",
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Pending",
      dataField: "pending",
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Completed",
      dataField: "completed",
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Status",
      dataField: "status",
    },
  ];

  // modal copy job plan
  const [showCopy, setShowCopy] = useState(false);
  const [showCancel, setShowCancel] = useState(false);

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if (list.includes(row.activity)) {
        if (row.activity === "RCI" && dataId.inbound_status === "1040") {
          history.push(`/inbound/workflow/edit/${id}`, 0);
        }
        if (row.activity === "PDI - In" && dataId.inbound_status === "1040") {
          history.push(`/inbound/workflow/edit/${id}`, 1);
        }
        if (row.activity === "PDI - Out" && dataId.inbound_status === "1040") {
          history.push(`/inbound/workflow/edit/${id}`, 2);
        }
        if (row.activity === "Storage" && dataId.inbound_status === "1040") {
          history.push(`/inbound/workflow/edit/${id}`, 3);
        }
      }
    },
  };

  const handleStart = async () => {
    const params = {
      inbound_id: id,
      inbound_status: "1040",
    };
    try {
      const response = await dispatch(editInboundSetstatus(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleConfirm = async () => {
    const params = {
      inbound_id: id,
      inbound_status: "1010",
    };
    try {
      const response = await dispatch(editInboundConfirm(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleAmend = async () => {
    const params = {
      inbound_id: id,
    };
    try {
      const response = await dispatch(editInboundAmend(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleDownloadUploadProgress = async (row) => {
    if (row == null || row.data == null || !(row.data instanceof Array) || row.data.length <= 0) {
      return;
    }

    const headers = Object.keys(row.data[0]);
    const shownIndexes = headers.map((h, i) => columnsExportExcel.find((c) => c.dataField === h) != null ? i : null).filter(x => x != null);

    const payload = {
      FileName: `Upload Result ${row.file_name}`,
      SheetName: 'Inbound Vehicle',
      Data: [
        headers.filter((v, i) => shownIndexes.includes(i)).map((h) => columnsExportExcel.find((c) => c.dataField === h)?.text || h)
      ],
      ConditionalIndex: headers.filter((v, i) => shownIndexes.includes(i)).findIndex((h) => h === 'status_validate'),
      misc_header_id : row.misc_header_id,
      index_select : shownIndexes
    };
      // for (let i = 0; i < row.data.length; i++) {
      //   const rowData = Object.keys(row.data[i]).map((key) => {
      //     return row.data[i][key] || '';
      //   });
      //   payload.Data.push(rowData.filter((v, i) => shownIndexes.includes(i)));
      // }

    try {
      const response = await dispatch(fetchGenerateExcel(payload));
      
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Upload Result ${row.file_name}.xlsx`;
        link.click();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  // handle UPload File
  const [showUploadView, setShowUploadView] = useState(false);
  const [rowUpload, setRowUpload] = useState(null);
  const [rowUploadStatus, setRowUploadStatus] = useState(null);

  const actionFileFormatter = (e, row, rowIndex) => {
    return (
      <div className="d-flex flex-nowrap">
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">View</Tooltip>}
        >
          <a
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
            onClick={() => {
              setRowUploadStatus(row.status);
              setRowUpload(row);
              setShowUploadView(true);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")} />
            </span>
          </a>
        </OverlayTrigger>
        {
          row.status === 'Completed' && (
            <OverlayTrigger
              overlay={<Tooltip id="vehicle-download-tooltip">Download</Tooltip>}
            >
              <a
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
                onClick={() => handleDownloadUploadProgress(row)}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/Download.svg")} />
                </span>
              </a>
            </OverlayTrigger>
          )
        }
      </div>
    );
  };
  const columnsFile = [
    {
      text: "Uploaded File",
      dataField: "file_name",
    },
    {
      text: "Status",
      dataField: "status",
    },
    {
      text: "Action",
      dataField: "Action",
      formatter: actionFileFormatter,
    },
  ];

  const inboundOptions = dataInbound.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const outboundOptions = dataOutbound.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const handleChangeInbound = (e, params) => {
    if (params === null) {
      setFormValues({
        ...formValues,
        ["inbound"]: {
          ...formValues["inbound"],
          value: "",
        },
      });
    } else {
      setFormValues({
        ...formValues,
        ["inbound"]: {
          ...formValues["inbound"],
          value: params.value,
        },
      });
    }
  };

  const handleChangeOutbound = (e, params) => {
    if (params === null) {
      setFormValues({
        ...formValues,
        ["outbound"]: {
          ...formValues["outbound"],
          value: "",
        },
      });
    } else {
      setFormValues({
        ...formValues,
        ["outbound"]: {
          ...formValues["outbound"],
          value: params.value,
        },
      });
    }
  };

  const indexOutbound = outboundOptions.findIndex(
    (obj) => obj.value === formValues.outbound.value
  );
  const indexInbound = inboundOptions.findIndex(
    (obj) => obj.value === formValues.inbound.value
  );

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {dataId && (
        <>
          <Card>
            <CardBody>
              <div className="d-flex justify-content-between">
                <p className=" font-size-h3 text-title-primary font-weight-boldest">
                  Inbound Job : {dataId.inbound_name}
                </p>
                {/* <Button className="my-btn-primary-dark d-flex justify-content-end">
                  Create Area
                </Button> */}
              </div>

              {/* Header */}

              <div
                className="m-2 d-flex bg-primary-dark align-items-center"
                style={{ borderRadius: "10px" }}
              >
                <div className="m-2 flex-fill font-weight-boldest text-center  text-white">
                  Job Date :{formatDate(dataId.job_date)}
                </div>
                <div className="m-2 flex-fill font-weight-boldest text-center text-white">
                  Client : {dataId.client_name}
                </div>
                <div className="m-2 flex-fill font-weight-boldest text-center text-white">
                  Shipper : {dataId.shipper_name}
                </div>
                <div className="m-2 flex-fill font-weight-boldest text-center text-white ">
                  Status : {statusInboundFormatter(dataId.inbound_status_name)}
                </div>
                <div className="m-2 flex-fill font-weight-boldest text-center text-white">
                  <Dropdown>
                    <Dropdown.Toggle className="primary" id="dropdown-basic">
                      Action
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {/* <Dropdown.Item
                        onClick={(e) => {
                          setShowCopy(true);
                        }}
                      >
                        Copy
                      </Dropdown.Item> */}
                      {dataId.inbound_status === "1010" && (
                        <>
                          <Dropdown.Item onClick={handleConfirm}>
                            Confirm
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={(e) => {
                              setShowCancel(true);
                            }}
                          >
                            Cancel
                          </Dropdown.Item>
                        </>
                      )}
                      {dataId.inbound_status === "1020" &&
                        dataId.is_amend === "Y" && (
                          <Dropdown.Item onClick={handleAmend}>
                            Amend
                          </Dropdown.Item>
                        )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>

              <ThemeProvider theme={formLabelsTheme}>
                <>
                  {/* Basic Detail */}
                  <div className="ml-2 mt-5">
                    <p className="font-weight-boldest">Basic Detail</p>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          required
                          label="Job Date"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          name="job_date"
                          value={formValues.job_date.value}
                          onChange={handleChange}
                          error={formValues.job_date.error}
                          helperText={
                            formValues.job_date.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                          disabled={
                            dataId.inbound_status !== "1010" ? true : false
                          }
                        />
                        <Autocomplete
                          disablePortal
                          name="inbound"
                          options={inboundOptions}
                          getOptionLabel={(option) => option.label.toString()}
                          // disableClearable={true}
                          onChange={handleChangeInbound}
                          value={
                            inboundOptions.find(
                              (option) =>
                                option.value === formValues.inbound.value
                            ) || null
                          }
                          renderInput={(params) => (
                            <RedditTextField
                              className={classes.margin}
                              {...params}
                              label="Inbound"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              placeholder="Select"
                              name="inbound"
                            />
                          )}
                        />
                        <Autocomplete
                          disablePortal
                          name="outbound"
                          options={outboundOptions}
                          getOptionLabel={(option) => option.label.toString()}
                          // disableClearable={false}
                          onChange={handleChangeOutbound}
                          value={
                            outboundOptions.find(
                              (option) =>
                                option.value === formValues.outbound.value
                            ) || null
                          }
                          renderInput={(params) => (
                            <RedditTextField
                              className={classes.margin}
                              {...params}
                              label="Outbound"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              placeholder="Select"
                              name="outbound"
                            />
                          )}
                        />
                        <RedditTextField
                          label="Estimated Time of Delivery"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          type="date"
                          name="estimate_delivery"
                          value={formValues.estimate_delivery.value}
                          onChange={handleChange}
                          disabled={
                            dataId.inbound_status !== "1010" ? true : false
                          }
                        />

                        <RedditTextField
                          label="Actual Time of Delivery"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          type="date"
                          name="actual_delivery"
                          value={formValues.actual_delivery.value}
                          onChange={handleChange}
                          disabled={
                            dataId.inbound_status !== "1010" ? true : false
                          }
                        />

                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              label="Port of Loading"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={formValues.port_of_loading_name.value}
                              readOnly
                              disabled={
                                dataId.inbound_status !== "1010" ? true : false
                              }
                            />
                          </Col>
                          {dataId.inbound_status === "1010" && (
                            <>
                              <Col xs={1} sm={1} md={1} lg={1}>
                                <div>
                                  <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                                    <span
                                      className="svg-icon svg-icon-md svg-icon-light"
                                      onClick={() => {
                                        setTypeLocation("loading");
                                        setGetData(true);
                                        setShowLocationMaster(true);
                                      }}
                                    >
                                      <SVG
                                        src={toAbsoluteUrl(
                                          "/media/svg/icons/New/Search.svg"
                                        )}
                                      />
                                    </span>
                                  </a>
                                </div>
                              </Col>
                              {formValues.port_of_loading_name.value !== "" && (
                                <Col xs={1} sm={1} md={1} lg={1}>
                                  <div
                                    style={{
                                      marginTop: "22px",
                                      marginRight: "12px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setFormValues({
                                        ...formValues,
                                        ["port_of_loading"]: {
                                          ...formValues["port_of_loading"],
                                          value: "",
                                        },
                                        ["port_of_loading_name"]: {
                                          ...formValues["port_of_loading_name"],
                                          value: "",
                                        },
                                      });
                                    }}
                                  >
                                    <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                                      <SVG
                                        src={toAbsoluteUrl(
                                          "/media/svg/icons/New/x-square.svg"
                                        )}
                                      />
                                    </span>
                                  </div>
                                </Col>
                              )}
                            </>
                          )}
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              label="Port of Discharge"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={formValues.port_of_discharge_name.value}
                              readOnly
                              disabled={
                                dataId.inbound_status !== "1010" ? true : false
                              }
                            />
                          </Col>
                          {dataId.inbound_status === "1010" && (
                            <>
                              <Col xs={1} sm={1} md={1} lg={1}>
                                <div>
                                  <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                                    <span
                                      className="svg-icon svg-icon-md svg-icon-light"
                                      onClick={() => {
                                        setTypeLocation("discharge");
                                        setGetData(true);

                                        setShowLocationMaster(true);
                                      }}
                                    >
                                      <SVG
                                        src={toAbsoluteUrl(
                                          "/media/svg/icons/New/Search.svg"
                                        )}
                                      />
                                    </span>
                                  </a>
                                </div>
                              </Col>
                              {formValues.port_of_discharge_name.value !==
                                "" && (
                                <Col xs={1} sm={1} md={1} lg={1}>
                                  <div
                                    style={{
                                      marginTop: "22px",
                                      marginRight: "12px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setFormValues({
                                        ...formValues,
                                        ["port_of_discharge"]: {
                                          ...formValues["port_of_discharge"],
                                          value: "",
                                        },
                                        ["port_of_discharge_name"]: {
                                          ...formValues[
                                            "port_of_discharge_name"
                                          ],
                                          value: "",
                                        },
                                      });
                                    }}
                                  >
                                    <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                                      <SVG
                                        src={toAbsoluteUrl(
                                          "/media/svg/icons/New/x-square.svg"
                                        )}
                                      />
                                    </span>
                                  </div>
                                </Col>
                              )}
                            </>
                          )}
                        </Row>
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          required
                          label="Job Type"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          name="Job Type"
                          value={dataId.job_type_name}
                          disabled
                        />
                        <RedditTextField
                          label="Estimated Time of Arrival"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          type="date"
                          name="estimate_arrival"
                          value={formValues.estimate_arrival.value}
                          onChange={handleChange}
                          disabled={
                            dataId.inbound_status !== "1010" ? true : false
                          }
                        />
                        <RedditTextField
                          label="Actual Time of Arrival"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          type="date"
                          name="actual_arrive"
                          value={formValues.actual_arrive.value}
                          onChange={handleChange}
                          disabled={
                            dataId.inbound_status !== "1010" ? true : false
                          }
                        />
                        <RedditTextField
                          required
                          label="Service Class"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          name="services_class"
                          value={dataId.services_class_name}
                          disabled
                        />
                      </Col>
                    </Row>
                  </div>
                  {/* handleSave */}
                  {dataId.inbound_status === "1010" && (
                    <Row className="mt-6 justify-content-end">
                      <Button variant="primary" onClick={handleSave}>
                        Save
                      </Button>
                    </Row>
                  )}

                  <hr />

                  {/* label */}
                  <div>
                    <p className="font-weight-boldest">Packages</p>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Total Vehicles </b>
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Label column sm={6}>
                              <b>{dataId.total_vehicle}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Net Weight </b>
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Label column sm={6}>
                              <b>{dataId.total_netweight}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                        <RedditTextField
                          label="Remarks"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          multiline
                          rows="4"
                          name="remarks"
                          value={formValues.remarks.value}
                          inputProps={{ maxLength: 150 }}
                          onChange={handleChange}
                          error={formValues.remarks.error}
                        />
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Volume </b>
                          </Form.Label>
                          <Col sm={6}>
                            {" "}
                            <Form.Label column sm={6}>
                              <b>{dataId.total_volume}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Gross Weight </b>
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Label column sm={6}>
                              <b>{dataId.total_grossweight}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                  <hr />
                  <div className="mb-3">
                    <p className="font-weight-boldest">Vehicle</p>
                    <div className="d-flex justify-content-end">
                      <div className="p-2 mt-3">Search By</div>
                      <div className="p-2" style={{ width: "180px" }}>
                        {" "}
                        <Select
                          options={vehiclesOptions}
                          value={getValueOptions(
                            vehiclesFilter,
                            vehiclesOptions
                          )}
                          placeholder="Select"
                          onChange={handleChangeVehicles}
                          required
                        />
                      </div>
                      <div className="p-2">
                        <Form.Control
                          type="text"
                          placeholder=""
                          onChange={(e) =>
                            setVehiclesFilterValue(e.target.value)
                          }
                          value={vehiclesFilterValue}
                        />
                      </div>
                      <div className="p-2">
                        {" "}
                        <Button variant="primary" onClick={handleSearch}>
                          Search
                        </Button>
                      </div>
                    </div>

                    {/* table */}

                    <BootstrapTable
                      remote
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      keyField="vehicle_id"
                      data={data === null ? [] : tableDataVehicle}
                      columns={columns}
                      pagination={paginationFactory(options)}
                      onTableChange={handleTableChange}
                      hover
                    >
                      <PleaseWaitMessage entities={loading ? null : data} />
                      <NoRecordsFoundMessage entities={loading ? null : data} />
                    </BootstrapTable>
                    {dataId.inbound_status === "1010" && (
                      <Row className="mt-6 justify-content-end">
                        <Button
                          variant="outline-primary mr-3"
                          onClick={(e) => {
                            setFileName("Upload Template File");
                            setFile(null);
                            setSelectedRows([]);
                            setTableData([]);
                            setShowUpload(true);
                          }}
                        >
                          Upload Vehicle
                        </Button>
                        <Button
                          variant="outline-primary"
                          onClick={(e) => setShowVehicle(true)}
                        >
                          Add Vehicle
                        </Button>
                      </Row>
                    )}
                  </div>
                  <hr />
                  <div className="mb-3">
                    <p className="font-weight-boldest">
                      Workflow of Inbound Job
                    </p>
                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      keyField="no"
                      data={
                        dataId.workFlowInboundJobs === null
                          ? []
                          : dataId.workFlowInboundJobs
                      }
                      columns={columnsWorkflow}
                      rowEvents={rowEvents}
                      hover
                    />

                    {dataId.inbound_status === "1020" && (
                      <Row className="mt-6 justify-content-end">
                        <Button variant="outline-primary" onClick={handleStart}>
                          Start Workflow
                        </Button>
                      </Row>
                    )}
                  </div>
                  <hr />
                  <div className="mb-3">
                    <p className="font-weight-boldest">File Upload Progress</p>
                    <Row>
                      <Col md={4}>
                        <BootstrapTable
                          wrapperClasses="table-responsive"
                          classes="table table-head-custom table-vertical-center overflow-hidden"
                          bootstrap4
                          keyField="no"
                          data={dataId.tableUploads}
                          columns={columnsFile}
                          hover
                        />
                      </Col>
                    </Row>
                  </div>
                </>
              </ThemeProvider>
            </CardBody>
          </Card>

          {/* Modal Create */}
          <VehicleCreate
            isOpen={showVehicle}
            setShow={setShowVehicle}
            handleSearch={handleSearch}
            formValues={formVehicle}
            setFormValues={setFormVehicle}
            row={row}
            setRow={setRow}
            // getData={getData}
            // setGetData={setGetData}
            getDataProduct={getDataProduct}
            setGetDataProduct={setGetDataProduct}
            getDataModel={getDataModel}
            setGetDataModel={setGetDataModel}
            getDataColor={getDataColor}
            setGetDataColor={setGetDataColor}
          />

          <VehicleUpload
            isOpen={showUpload}
            setShow={setShowUpload}
            fileName={fileName}
            setFileName={setFileName}
            file={file}
            setFile={setFile}
            tableData={tableData}
            setTableData={setTableData}
            id={id}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
          />
          <VehicleUploadView
            isOpen={showUploadView}
            setShow={setShowUploadView}
            setRowUpload={setRowUpload}
            rowUpload={rowUpload}
            rowUploadStatus={rowUploadStatus}
            setRowUploadStatus={setRowUploadStatus}
          />

          <ModalLocationMasterRadio
            isOpen={showLocationMaster}
            setShow={setShowLocationMaster}
            setFormValues={setFormValues}
            formValues={formValues}
            setFields={setFields}
            fields={fields}
            typeLocation={typeLocation}
            setTypeLocation={setTypeLocation}
            getData={getData}
            setGetData={setGetData}
          />

          <InboundCopy
            isOpen={showCopy}
            setShow={setShowCopy}
            id={id}
            name={dataId.inbound_name}
          />
          <InboundCancel
            isOpen={showCancel}
            setShow={setShowCancel}
            id={id}
            name={dataId.inbound_name}
          />
        </>
      )}
    </>
  );
};
